module.exports = __webpack_public_path__ + "img/2020_12_10_hairy_pickle.5a90f25d.jpg";